export const setTopNavBarProps = (props: { height: string; borderColor: string }): void => {
  document.body.style.setProperty("--top-nav-bar-height", props.height);
  document.body.style.setProperty("--top-nav-bar-border-color", props.borderColor);
};
